import { AvailableCurrenciesTable } from "@/components/AvailableCurrenciesTable";

export function CurrenciesPage() {
  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <h1 className="mb-6 text-2xl font-bold">Currencies</h1>
      <AvailableCurrenciesTable />
    </div>
  );
}
